<template>
	<c-dialog ref="dialog" width="550" height="400" @resolve="editRoleHandle">
		<c-form ref="form" vertical unit-width="100%">
            <c-input type="hidden" name="user_ids"></c-input>
			<c-form-item label="目标用户" required tip="修改选中用户的角色，同时将角色的权限授权给用户">
                <c-input type="textarea" name="user_realnames" maxlength="500" disabled></c-input>
            </c-form-item>
            <c-form-item label="角色" required tip="所选角色的所有权限将全部授权给目标用户">
                <c-select name="role_ids" async multiple @search="searchRole"></c-select>
            </c-form-item>
        </c-form>
	</c-dialog>
</template>

<script>
	import {mapState} from "vuex";

    export default {
		data() {
			return {
			}
		},
        computed: {
            // 获取dictName选项数据
            ...mapState(['refClientOptions']),
        },
		methods: {
			/************打开复制权限弹框**************/
			open(data) {
				this.$refs.form.clear();
				if (data) {
                    this.$refs.form.set({
                        user_ids: data.user_ids,
                        user_realnames: data.user_realnames,
                    });
                }
				//填充form表单
				this.$refs.dialog.open({
					title: '复制角色权限'
				});
			},

            /*******搜索角色*****************/
            searchRole(keyword, resolve){
                this.request({
                    url:'/system/native/options',
                    data: {
                        options_code:'ROLE',
                        keyword:keyword
                    },
                    success:data => {
                        resolve(data);
                    }
                })
            },

			/************修改角色提交处理方法*******************************/
            editRoleHandle (stop, next){
				stop();
				this.$refs.form.submit({
					url: '/sys_user/batch_edit_role',
					dataFormatter: data => {
                        data.role_ids = data.role_ids.join(',');
						return data;
					},
					rule: {
                        user_ids: '请至少选择一个用户',
                        role_ids: '请至少选择一个角色'
					},
					success: (data, res) => {
						next();
						this.$message({
							message: '权限复制成功',  // 提示内容,
							type: 'success'
						});
						this.$emit('resolve');
					}
				});
			}
		}
	}
</script>

<style lang="stylus" scoped>
</style>